import fs from "fs";
import path from "path";

export async function logAllRequests(context = {}) {
    if (!context.ctx || !context.ctx.req) return; // Ensure ctx and req exist

    const { req, res } = context.ctx;
    const logDirectory = "/opt/logs";
    const accessLogFile = path.join(logDirectory, "access.log");
    const errorLogFile = path.join(logDirectory, "error.log");

    try {
        // Ensure log directory exists
        if (!fs.existsSync(logDirectory)) {
            fs.mkdirSync(logDirectory, { recursive: true });
        }

        // Capture request details
        const statusCode = res?.statusCode || "N/A";
        const logEntry = `[${new Date().toISOString()}] ${statusCode} ${req.method} ${req.url} ${req.headers["user-agent"]}\n`;

        // Log errors separately
        if (statusCode >= 400) {
            await fs.promises.appendFile(errorLogFile, logEntry, "utf8");
        } else {
            await fs.promises.appendFile(accessLogFile, logEntry, "utf8");
        }
    } catch (error) {
        console.error("Failed to log request:", error);
    }
}
